module.exports = __webpack_public_path__ + "static/media/login_wallpaper_mobile.6e04492c.d12c0e5d.webp";